import type { VoidFunctionComponent } from 'react';

import { BINARY_DECOMPOSITION } from '../../../../../../../../../../shared/featureFlags/flagNames';
import { ProjectSource } from '../../../../../../../../../../typings/enums';
import { useIsFeatureEnabled } from '../../../../../../../../../helpers/features';
import { selectOptionFactory } from '../../../../../../../../../utils';
import FilterCard from '../../../../../../../../generic/Filter/FilterCard';
import type { ProjectsFilter } from '../../../../../../../../../../shared/projectsV2';
import type { SelectOption } from '../../../../../../../../../types';

type Props = {
  setFilters: (filter: ProjectsFilter) => void;
  filters: ProjectsFilter;
};

export const PROJECT_SOURCE_OPTIONS = [
  selectOptionFactory(ProjectSource.Provided, 'CLI upload'),
  selectOptionFactory(ProjectSource.Container, 'Container'),
  selectOptionFactory(ProjectSource.Archive, 'Archive upload'),
  selectOptionFactory(ProjectSource.Autobuild, 'Quick import'),
  selectOptionFactory(ProjectSource.SBOM, 'SBOM import'),
  selectOptionFactory(ProjectSource.Binary, 'Binary Decomposition'),
];

export const ProjectSourceFilter: VoidFunctionComponent<Props> = ({ setFilters, filters }) => {
  // Binary Decomposition project attribute should only be displayed when feature is enabled.
  const isBinaryDecompositionEnabled = useIsFeatureEnabled(BINARY_DECOMPOSITION);
  const options = PROJECT_SOURCE_OPTIONS.filter(
    entry => (isBinaryDecompositionEnabled || entry.value !== 'binary'));

  const handleSourceChange = (selected: SelectOption[]) => {
    setFilters({ ...filters, type: selected.map((selection) => selection.value) as ProjectsFilter['type'] });
  };

  const selectedProjectSources = filters.type?.map((selectedType) => selectOptionFactory(selectedType));

  return (
    <FilterCard.Checkboxes
      label="Project source"
      options={options}
      values={selectedProjectSources ?? []}
      onChange={handleSourceChange}
    />
  );
};
